import React from "react";
import Hero from "../components/sections/Hero.jsx";
import TechnicalExpertise from "../components/sections/TechnicalExpertise";
import RavlOfferings from "../components/sections/RavlOfferings";

const Home = () => {
  return (
    <div>
      <Hero />
      <div className="container mx-auto">
        <TechnicalExpertise />
        <RavlOfferings />
      </div>
    </div>
  );
};

export default Home;
